module.exports = __webpack_public_path__ + "img/inactivedownarrow.794fd76a.svg";